import { render } from "./Gallery-index.vue?vue&type=template&id=a849f2b2"
import script from "./Gallery-index.vue?vue&type=script&lang=js"
export * from "./Gallery-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__